<template>
  <div>
    <div class="main-title">按单据退款
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.date_field" style="width:120px;" @change="search(searchParams)">
              <el-option label="训练日期" value="daterange"></el-option>
              <el-option label="退款日期" value="prepaid_refund_time"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="单据编号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              style="width:120px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="教练姓名"
              v-model="searchForm.coach_name"
              prefix-icon="el-icon-search"
              clearable
              style="width:120px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.prepaid_is_refund" placeholder="退款状态" style="width:120px;" @change="search(searchParams)">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="未退款" value="0"></el-option>
              <el-option label="已退款" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-button style="margin-bottom:10px" v-if="selectRows.length > 0" @click="multiPrint">打印单据</el-button>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="bill_no"
          label="单据编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="应收金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee_discount"
          label="优惠"
          width="70">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="prepaid_is_refund"
          label="退款状态"
          width="80">
          <template slot-scope="scope">
            {{scope.row.prepaid_is_refund === '1' ? '已退款' : '未退款'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="prepaid_refund_money"
          label="退款金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="prepaid_refund_time"
          label="退款时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="secu_name"
          label="安全员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="160">
        </el-table-column>
        <el-table-column
          label="学员"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="showStudent(scope.row)">{{scope.row.student_count}}个学员</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="结束时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="110">
        </el-table-column>
        <el-table-column
          prop="pay_cash"
          label="现金"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_alipay"
          label="支付宝"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_wechat"
          label="微信支付"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_pos"
          label="银行卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_balance"
          label="充值卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_coupon"
          label="代金券"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_virtual"
          label="挂账"
          width="80"
          v-if="user.pay_virtual == '1'">
        </el-table-column>
        <el-table-column
          prop="pay_advance"
          label="预收"
          width="80"
          v-if="user.pay_advance == '1'">
        </el-table-column>
        <el-table-column
          prop="route_name"
          label="训练路线"
          width="80">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="培训服务"
          width="80"
          v-if="user.group_id == 1">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="类型"
          width="80"
          v-if="user.group_id == 32">
        </el-table-column>
        <el-table-column
          prop="sales_name"
          label="业务员"
          width="70"
          v-if="[1,10].indexOf(user.group_id) >= 0">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="300">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="90">
          <template slot-scope="scope">
            <el-button v-if="scope.row.prepaid_is_refund === '0'" type="text" @click="edit(scope.row)">退款</el-button>
            <el-button v-if="scope.row.prepaid_is_refund === '1'" type="text" @click="print(scope.row)">打印</el-button>
            <el-button v-if="scope.row.prepaid_is_refund === '1' && scope.row.prepaid_refund_time.indexOf(today) === 0" type="text" @click="edit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 学员信息窗口 -->
    <el-dialog title="学员信息" :visible.sync="studentDialogVisible">
      <div v-if="studentLoading" style="height:100px;text-align:center;">正在加载学员信息...</div>
      <el-table v-if="!studentLoading" :data="studentList">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="idcard" label="身份证号"></el-table-column>
        <el-table-column label="操作" v-if="selectRow.pay_status == '未支付'">
          <template slot-scope="scope">
            <el-button type="text" style="color:#f56c6c;" @click="delStudent(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="!studentLoading"
        title="提示:已结算的单据不能再增加或删除学员"
        type="info"
        style="margin-top:10px;"
        :closable="false">
      </el-alert>
    </el-dialog>
    <!-- 退款表单 -->
    <el-dialog :title="formTitle" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="200px">
        <el-form-item label="退款金额">
          <el-input v-model.number="form.prepaid_refund_money"></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="refund_pay_type">
          <el-select v-model="form.refund_pay_type" placeholder="请选择支付方式" style="width:194px;">
            <el-option label="现金" value="现金"></el-option>
            <!-- <el-option label="支付宝" value="pay_alipay"></el-option>
            <el-option label="微信支付" value="pay_wechat"></el-option> -->
            <el-option label="银行卡" value="银行卡"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editCommit" :loading="editCommiting">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  props: {
    user: Object
  },
  data () {
    return {
      sqlcode: 'bill_list_refund',
      fixedParams: {
        pay_status: '已支付'
      },
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        coach_name: '',
        date_field: 'daterange',
        daterange: [
          // new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
          this.user.buttons.indexOf(1020) < 0 ? new Date() : new Date().setTime(new Date().getTime() - 3600 * 1000 * 24),
          new Date()
        ],
        prepaid_is_refund: null
      },
      formVisible: false,
      formTitle: '退款',
      form: {
        id: 0,
        prepaid_refund_money: 0,
        refund_type: '0',
        remark: '',
        refund_pay_type: '现金'
      },
      editCommiting: false,
      sumProps: [
        'use_time',
        'fee',
        'fee_discount',
        'pay_total',
        'pay_cash',
        'pay_alipay',
        'pay_wechat',
        'pay_pos',
        'pay_balance',
        'pay_coupon',
        'pay_virtual',
        'pay_advance',
        'prepaid_refund',
        'prepaid_refund_money'
      ],
      billDialogVisible: false,
      selectRow: {},
      studentDialogVisible: false,
      studentLoading: false,
      studentList: [],
      today: moment().format('YYYY-MM-DD'),
      accountList: [],
      formRules: {
        pay_type: [
          { required: true, message: '请选择支付方式', trigger: "blur" }
        ]
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        if (this.searchForm.date_field === 'prepaid_refund_time') {
          return {
            company_ids: this.searchForm.company_ids,
            query: this.searchForm.query,
            coach_name: this.searchForm.coach_name,
            prepaid_is_refund: this.searchForm.prepaid_is_refund,
            prepaid_refund_time_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
            prepaid_refund_time_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
          }
        } else {
          return {
            company_ids: this.searchForm.company_ids,
            query: this.searchForm.query,
            coach_name: this.searchForm.coach_name,
            prepaid_is_refund: this.searchForm.prepaid_is_refund,
            daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
            daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
          }
        }
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.prepaid_is_refund === '1') {
        return 'row-green'
      } else {
        return ''
      }
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (this.sumProps.indexOf(column.property) >= 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'company_name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    edit (row) { // 修改信息
      this.form.id = row.id
      this.form.prepaid_refund_money = 0
      this.form.remark = row.remark
      this.formVisible = true
    },
    editCommit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.editCommiting = true
          this.$http.post('/dbapi/bill_prepaid_refund', this.form).then(response => {
            this.editCommiting = false
            if (response.data.success) {
              this.formVisible = false
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    showStudent (row) { // 显示学员窗口
      this.selectRow = row
      this.studentDialogVisible = true
      this.studentLoading = true
      this.$http.get('/dbapi/student_list?car_id=0&bill_id=' + row.id).then(response => {
        this.studentLoading = false
        if (response.data.success) {
          this.studentList = response.data.list
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    print (row) {
      window.open(this.$http.receiptBaseUrl + '/prepaid_refund_print?id=' + row.id + '&token=' + localStorage.getItem('kaochang.token'))
    },
    multiPrint () {
      let ids = ''
      for (var i = 0; i < this.selectRows.length; i++) {
        ids += '&ids=' + this.selectRows[i].id
      }
      window.open(this.$http.receiptBaseUrl + '/prepaid_refund_print?token=' + localStorage.getItem('kaochang.token') + ids)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/return/Refund.vue